import { render, staticRenderFns } from "./WidgetReviewsListV3Mobile.vue?vue&type=template&id=1a49e645"
import script from "./WidgetReviewsListV3Mobile.vue?vue&type=script&lang=js"
export * from "./WidgetReviewsListV3Mobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports